<div [formGroup]="parent">
  <div class="form-field" [ngClass]="{'has-error': parent.get(controllerData.controlName).touched
&& parent.get(controllerData.controlName).errors}">
    <div class="col-md-12 clear-all tooltip-flex-container">
      <label for="{{controllerData['name']}}" class="form-label"
        [id]="'lbl-'+controllerData['label']">{{controllerData['label']}}</label>
      <div class="info-icon d-view" *ngIf="controllerData['name'] === 'addressline1' && (pageName === 'registration' || pageName === 'register')">
        <app-tool-tip-notification [childId]="'addressToolTipInfoConfig'" [tooltipData]="tooltipData"
          class="col-sm-1 padding-for-toolTip" (onDisplayMobileTooltipEmitter)="displayTooltipMessage('firstname')">
        </app-tool-tip-notification>
      </div>
      <div class="col-md-12 clear-all info-icon mt-view" *ngIf="controllerData['name'] === 'addressline1' && (pageName === 'registration' || pageName === 'register')">
        <app-tool-tip-notification [childId]="'addressToolTipInfoConfig'" [tooltipData]="tooltipData"
          (onDisplayMobileTooltipEmitter)="displayTooltipMessage('firstname')">
        </app-tool-tip-notification>
      </div>
    </div>

    <div class="form-field-text">
      <input [formControlName]="controllerData['controlName']" [name]="controllerData['name']" type="text"
        [id]="controllerData['name']" [(ngModel)]="textValue" aria-invalid="false"
        [placeholder]="controllerData['placeHolder']" [maxlength]="controllerData['maxlength']" class="form-control"
        [value]="controllerData['value']" [required]="controllerData['required']"
        (blur)="inputTextChangeHandler($event.target.value)" />

    </div>

    <app-modal *ngIf="displayTooltipAlert" [modalConfig]="tooltipModalConfig" (closeModal)="closeTooltipModal()"
      (primaryBtnClick)="alertTooltipPrimaryBtnClick($event)" (secondaryBtnClick)="alertSecondaryBtnClick()"
      [tooltipFlag]="true"></app-modal>

    <div [id]="controlName +'-error'" class="form-validation-error" *ngIf="parent.get(controlName).touched
                        &&
                    parent.get(controlName).errors">
      <i class="icon icon-error" aria-hidden="true"></i>
      <p *ngIf="parent.get(controlName).touched
                        &&
                      parent.get(controlName).hasError('required')" [id]="controlName +'-error'">
        {{controllerData['errorMessage']}}</p>

    </div>
  </div>
</div>